// extracted by mini-css-extract-plugin
export default {"departments":"zG-z","departmentHeading":"AG-z","departmentSection":"BG-z","departmentName":"CG-z","departmentLink":"DG-z","expandIcon":"EG-z"};